import getShopMenu from '@services/menu/getShopMenu';
import { errorAction, successfulAction } from '@shared/actions';
import { STATUS_CODE, SHOP_DELIVERY_TYPE } from '@shared/constants';
import getShopBusinessType from '@core/reducers/shop/selectors/getShopBusinessType';
import { BUSINESS_TYPE } from '@commons/constants';
import { FETCH_EXTENDED_MENU } from '../actionTypes';

const type = FETCH_EXTENDED_MENU;
const errorCode = STATUS_CODE.INTERNAL_ERROR;

const fetchExtendedMenu = ({ shop, isPickup }) => async (
  dispatch,
  getState,
  axios,
) => {
  try {
    dispatch({ type });
    const state = getState();
    const businessType = getShopBusinessType(state);

    if (businessType === BUSINESS_TYPE.COURIER) {
      dispatch(
        errorAction({
          type,
          error: new Error("This shop doesn't have a menu"),
          errorCode,
        }),
      );
    }

    const params = {
      axios,
      shopId: shop.id,
      isJoker: false,
      occasion: isPickup
        ? SHOP_DELIVERY_TYPE.PICK_UP
        : SHOP_DELIVERY_TYPE.DELIVERY,
    };

    const { success, data, error } = await getShopMenu(params);

    if (!success) {
      dispatch(errorAction({ type, error, errorCode }));
      return;
    }

    dispatch(successfulAction({ type, payload: { menu: data } }));
  } catch (error) {
    dispatch(errorAction({ type, error, errorCode }));
  }
};

export default fetchExtendedMenu;
